import { get as getProperties } from './propiedades'
import { getPropertyTypes, addAdministrativeAreaSync, resetFiltersSync } from './searchBar'
import { getImisWithFilter } from './imi'
import { getNewsletterWithFilter } from './newsletter'
import { sendContactForm } from './contactForm'
import * as propertyCodesForForms from '../constants/propertyCodesForForms'
import * as urls from '../constants/api'

export const _typesToParam = (storeTypes) => {
  var typesParam = []
  if (storeTypes !== undefined) {
    for (var i = 0; i < storeTypes.length; i+=1) {
      if (storeTypes[i].id != '')
        typesParam.push(storeTypes[i].id)
    }
  }
  return typesParam
}

export const _idsOfParam = (storeTypes) => {
  var typesId= []
  if (!storeTypes){
    return []
  }
  for (var i = 0; i < storeTypes.length; i+=1) {
    typesId.push(storeTypes[i].value)
  }
  return typesId
}

export const _paramsForHotels = (store) => {
  let params = ''
  params = {
     category_type_id: 13,
     order_by: store.meta.order_by,
  }
  return params
}

export const _paramsForFields = (store) => {
  let params = ''
  params = {
     category_type_id: 9,
     order_by: store.meta.order_by
  }
  return params
}

export const pick = params => {
  let ret = {}
  let attrs = [
    'operation_type_id',
    'category_type_id',
    'property_type_id',
    'administrative_areas',
    'area_min',
    'area_max',
    'price_min',
    'price_max',
    'currency_type_id',
    'order_by',
    'venture_ids',
    'land_uses',
    'page'
  ]

  for (var param in params) {
    if (attrs.indexOf(param) !== -1 && (
      ( params[param] && typeof params[param].length == 'undefined' ) ||
      ( params[param] && typeof params[param].length !== 'undefined' && params[param].length > 0 )
    ))
    ret[param] = params[param]
  }
  return ret
}

export const paramsForProperties = (store) => {
  let params = ''

  let operation_type_id = _typesToParam(store.searchBar.operation_type)
  let property_type_id = _typesToParam(store.searchBar.property_type)
  let category_type_id = store.searchBar.originPath.id
  let subsidiary_type_id = store.searchBar.originOffice.subsidiary == 5
    ? 2
    : store.searchBar.originOffice.subsidiary

  if (!property_type_id || !property_type_id.length) {
    switch(category_type_id) {
      // case '1':
      //   property_type_id = [5];
      //   break;
      // case '2':
      //   property_type_id = [1, 24, 14];
      //   break;
      // case '3':
      //   property_type_id = [7];
      //   break;
      case '7':
        property_type_id = [1];
        break;
    }
  }

  if (category_type_id == '7') {
    category_type_id = ''
  }

  // params when searching from searchbar
  if ((store.searchBar.show) || (store.searchBar.searchFromMenu)) {
      params = {
        property_type_id: property_type_id,
        operation_type_id: operation_type_id,
        category_type_id: category_type_id,
        subsidiary_type_id: subsidiary_type_id,
        order_by: store.meta.order_by,
        administrative_areas: _idsOfParam(store.searchBar.administrative_areas_selected),
        ambients: (store.searchBar.ambients == '-') ? '' : store.searchBar.ambients,
        bathrooms: (store.searchBar.bathrooms == '-') ? '' : store.searchBar.bathrooms,
        garages: (store.searchBar.garages == '-') ? '' : store.searchBar.garages,
        bedrooms: (store.searchBar.bedrooms == '-') ? '' : store.searchBar.bedrooms,
        land_uses: _typesToParam (store.searchBar.terrain),
        category_id: _typesToParam (store.searchBar.category),
        unit_state: _typesToParam (store.searchBar.unit_state),
        floor_types: _typesToParam (store.searchBar.plant_type),
        focus_id: _typesToParam (store.searchBar.focus),
        avenue_id: _typesToParam(store.searchBar.avenue),
        price_min: (store.searchBar.price_min == '-') ? '' : store.searchBar.price_min,
        price_max: (store.searchBar.price_max == '-') ? '' : store.searchBar.price_max,
        currency_type_id: store.searchBar.currency,
        area_min: (store.searchBar.area_min == '-') ? '' : store.searchBar.area_min,
        area_max: (store.searchBar.area_max == '-') ? '' : store.searchBar.area_max,
        area_max_low_level: (store.searchBar.area_low_max == '-') ? '' : store.searchBar.area_low_max,
        area_min_low_level: (store.searchBar.area_low_min == '-') ? '' : store.searchBar.area_low_min,
        is_brand_new: store.residential.is_new,
        venture_ids: [],
        is_professional_use: store.residential.is_professional_use,
        nave: store.searchBar.naves,
        page: store.meta.page
      }

			if(store.searchBar.ubication.length) params['ubication'] = store.searchBar.ubication[0].id

			if(store.searchBar.sub_property_type  || store.searchBar.sub_departamento_type){
				if(store.searchBar.sub_property_type  && !store.searchBar.sub_departamento_type.length){
					params['property_type_id']= [store.searchBar.sub_property_type.id]
				} else if(store.searchBar.sub_departamento_type.length) {
					params['property_type_id'] = []
					for(var val of store.searchBar.sub_departamento_type){
						params['property_type_id'].push(val.id)
					}
				}
			}
  }
  // params on page reload
  else {
    console.log('store.searchBar.terrain ', store.searchBar.terrain);
    params = {
      property_type_id: property_type_id,
      operation_type_id: operation_type_id,
      category_type_id: category_type_id,
      subsidiary_type_id: subsidiary_type_id,
      order_by: store.meta.order_by,
      administrative_areas: _idsOfParam(store.searchBar.administrative_areas_selected),
      venture_ids: [],
      land_uses: store.searchBar.terrain && store.searchBar.terrain.length
        ? store.searchBar.terrain.map(op => op.id) : [],
      price_min: (store.searchBar.price_min == '-') ? '' : store.searchBar.price_min,
      price_max: (store.searchBar.price_max == '-') ? '' : store.searchBar.price_max,
      currency_type_id: store.searchBar.currency,
      area_min: (store.searchBar.area_min == '-') ? '' : store.searchBar.area_min,
      area_max: (store.searchBar.area_max == '-') ? '' : store.searchBar.area_max,
      page: store.meta.page
    }

		if(store.searchBar.sub_property_type  || store.searchBar.sub_departamento_type){
      if(store.searchBar.sub_property_type  && !store.searchBar.sub_departamento_type.length){
        params['property_type_id']= [store.searchBar.sub_property_type.id]
			} else if(store.searchBar.sub_departamento_type.length) {
        params['property_type_id'] = []
				for(var val of store.searchBar.sub_departamento_type){
          params['property_type_id'].push(val.id)
				}
			}
    }
  }

  if(store.entrepreneurship.id) {
    params['venture_ids'].push(parseInt(store.entrepreneurship.id))
  }
  // }
  console.log('params ', params);
  return params
}

export const _defaultsParamsForProperties = (store, pl) => {
  let params = {
    p: store.meta.page,
    pl: pl || store.meta.page_lenght
  }
  return params
}

export const getPropertyCodes = (contactFormStore) => {
  if (contactFormStore.property_code) {
    return [contactFormStore.property_code]
  } else {
    const key = `${contactFormStore.pathName || 'residencial'}${contactFormStore.officeName ? ('_' + contactFormStore.officeName) : ''}`
    if (propertyCodesForForms.hasOwnProperty(key.toLocaleLowerCase())) {
      return [propertyCodesForForms[key.toLocaleLowerCase()]]
    }
  }
  return [propertyCodesForForms['home']]
}

const branchNameBySector = {
  home: 'Landing Home',
  residencial: 'Landing Residencial',
  pilar: 'Landing Pilar ',
  sanisidro: 'Landing Residencial San Isidro',
  palermo: 'Landing Residencial Baires',
  escobar: 'Landing Escobar',
  recoleta: 'Landing Residencial Baires',
  puertos: 'Landing Puertos',
  nordelta: 'Landing Nordelta',
  locales: 'Landing Retail',
  oficinas: 'Landing Oficinas',
  oficina: 'Landing Oficinas',
  industrias: 'Landing Industrias',
  hoteles: 'Landing Hoteles',
  campos: 'Landing Campos',
  emprendimientos: 'Landing Emprendimientos',
  terrenos: 'Landing Terrenos',
  tasaciones: 'Landing Tasaciones',
}

const contactTagInfoRules = [
  {
    key: 'Consulta Web',
    strategy: () => 'Web Ljramos',
  },
  {
    key: 'TIPO PROPIEDAD',
    strategy: (contactFormRawInfo) => contactFormRawInfo.property_type,
  },
  {
    key: 'TIPO OPERACION',
    strategy: (contactFormRawInfo) => contactFormRawInfo.operation_type,
  },
  {
    key: 'SECTOR',
    strategy: (contactFormRawInfo) => {
      const { sector_id, officeName, branch }  = contactFormRawInfo
      let key
      if (!branch) {
        key = officeName || sector_id || 'home'
      } else {
        return branch.name
      }
      return key
        // eslint-disable-next-line no-prototype-builtins
        && branchNameBySector.hasOwnProperty(key.toLocaleLowerCase())
        && branchNameBySector[key.toLocaleLowerCase()]
    },
  },
]

const getContactInfoTags = (contactFormRawInfo) => {
  return contactTagInfoRules.map((rule) => {
    const { key, strategy } = rule
    const value = strategy(contactFormRawInfo)
    if (value) {
      return `${key}: ${value}`
    }
  })
  .filter(val => val)
}

export const _paramsForContactForm = (store) => {
  let params = ''
  params = {
    name: store.contactForm.name,
    telephone: store.contactForm.phone,
    phone: store.contactForm.phone,
    email: store.contactForm.email,
    body: store.contactForm.query,
    text: store.contactForm.query,
    sector_id: store.contactForm.sector,
    property_code: store.contactForm.property_code,
    // properties: [store.contactForm.property_code],
    properties: getPropertyCodes(store.contactForm),
    tags: getContactInfoTags(store.contactForm),
    broker_id: store.contactForm.broker_id,
    director_id: store.contactForm.director_id,
    subsidiary_id: store.contactForm.subsidiary_id,
    sector_id: store.contactForm.sector_id,
    broker: store.contactForm.broker,
    director: store.contactForm.director,
    subsidiary: store.contactForm.subsidiary,
    sector: store.contactForm.sector,
  }
  return params
}

export const fetchSection = (value, allSectors = false) => {
  return (dispatch, getStore) => {
    var store = getStore()
    var val = value || store.routing.locationBeforeTransitions.pathname

    switch (val) {
      case urls.PROPERTIES :
        var params = paramsForProperties(store)
        var defaults = _defaultsParamsForProperties(store)
        dispatch(getProperties(params, defaults))
        break
      //for each landing, differents ids to get differents property types for searchbar
      //isSector : false => gets the childrens of the sector
      case urls.HOME :
        var params = {}
        dispatch(getPropertyTypes(params))
        break
      case urls.RESIDENTIAL:
        if (value == store.routing.locationBeforeTransitions.pathname) {
          var params = { category_type_id: 6 }
          dispatch(getPropertyTypes(params))
        }
        break
			case urls.PUERTOS :
        var params = { subsidiary_type_id: 1 }
        dispatch(getPropertyTypes(params))
        break
      case urls.OFFICES :
        var params = { category_type_id: 1 }
        dispatch(getPropertyTypes(params));
        break;
			case urls.PROPERTIES_HOME :
        var params = {}
        dispatch(getPropertyTypes(params))
        break
      case urls.LOCAL:
        var params = { category_type_id: 3 }
        dispatch(getPropertyTypes(params));
        break;
      case urls.INDUSTRIES:
        var params = { category_type_id: 2 }
        dispatch(getPropertyTypes(params));
        break;
      case urls.TERRAINS :
        var params = { category_type_id: 7, }
        dispatch(getPropertyTypes(params));
        break
      case urls.ENTREPENEURSHIP :
        var params = { category_type_id: 8 }
        dispatch(getPropertyTypes(params));
        break;
      case urls.FIELDS :
        var params = _paramsForFields(store)
        var defaults = _defaultsParamsForProperties(store, 6)
        dispatch(getProperties(params, defaults))
        break
      case urls.HOTELS :
        var params = _paramsForHotels(store)
        var defaults = _defaultsParamsForProperties(store)
        dispatch(getProperties(params, defaults))
        break
      case urls.ADMINISTRATIVEAREAS :
        dispatch(resetFiltersSync())
        dispatch(addAdministrativeAreaSync(store.administrativeArea.detail.ids.map((v)=>({value:v, zone:false}))))
        break
      case 'contactForm' :
        var params = _paramsForContactForm(store)
        dispatch(sendContactForm(params))
    }
  }
}

export const fetchImis = () => {
  return (dispatch, getStore) => {
    var store = getStore()
    let month = store.imi.month
    let year = store.imi.year
    dispatch(getImisWithFilter(month, year))
  }
}

export const fetchNewsletter = () => {
  return (dispatch, getStore) => {
    var store = getStore()
    let month = store.newsletter.month
    let year = store.newsletter.year
    dispatch(getNewsletterWithFilter(month, year))
  }
}

export const fetchFilteredNeighborhoods = () => {
  return (dispatch, getStore) => {
    var store = getStore()
    let params = {
      property_type_id: _typesToParam(store.searchBar.property_type),
      operation_type_id: _typesToParam(store.searchBar.operation_type),
      category_type_id: store.searchBar.originPath.id,
      subsidiary_type_id: store.searchBar.originOffice.subsidiary,
    }

    /*
		if(store.searchBar.sub_property_type){
			if(params['property_type_id'].indexOf(store.searchBar.sub_property_type) == -1){
				params['property_type_id'].push(store.searchBar.sub_property_type.id)
			}

			if(store.searchBar.sub_departamento_type){
				for(var val of store.searchBar.sub_departamento_type){
					params['property_type_id'].push(val.id);
				}
			}
		}
    */
    return params
    //dispatch(loadNeighborsByZone(params));
  }
}
export const fetchFilteredAdministrativeAreas = () => {
  return (dispatch, getStore) => {
    let store = getStore()

    let operation_type_id = _typesToParam(store.searchBar.operation_type)
    let property_type_id = _typesToParam(store.searchBar.property_type)
    let category_type_id = store.searchBar.originPath.id
    let subsidiary_type_id = store.searchBar.originOffice.subsidiary

    if (!property_type_id || !property_type_id.length) {
      switch(category_type_id) {
        // case '1':
        //   property_type_id = [5]
        //   break
        // case '2':
        //   property_type_id = [14]
        //   break
        // case '3':
        //   property_type_id = [7]
        //   break
        case '7':
          property_type_id = [1]
          break
      }
    }

    if (category_type_id == '7') {
      category_type_id = ''
    }

    let params = {
      property_type_id: property_type_id,
      operation_type_id: operation_type_id,
      category_type_id: category_type_id,
      subsidiary_type_id: subsidiary_type_id
    }
    return params
  }
}


export const fetchFilteredPropertyTypes = () => {
  return (dispatch, getStore) => {
    var store = getStore()
    let params = {
      property_type_id: _typesToParam(store.searchBar.property_type),
      operationType: _typesToParam(store.searchBar.operation_type),
      category_type_id: store.searchBar.originPath.id,
      subsidiary_type_id: store.searchBar.originOffice.subsidiary,
      isSector: true,
    }
    return params
  }
}



// WEBPACK FOOTER //
// ./src/actions/api.js